<style lang="scss" scoped>
@use 'sass:color';
@use '../palette.scss' as *;

.first-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-flow: row nowrap;

    .custom-msg-ctn {
        display: flex;
        align-items: center;
        padding: 10px;
        max-width: 80%;
        flex-grow: 1;

        .custom-msg {
            font-weight: bold;
            white-space: nowrap;
            margin-right: 10px;
        }

        .input-box-container {
            max-width: 600px;
            flex-grow: 1;
            margin-right: 10px;
        }
    }

    .button {
        min-width: 80px;

        .fa-check {
            margin-right: 8px;
        }
    }
}

.acknowledge-container {
    width: 100%;
    display: flex;
    justify-content: center;

    .button {
        min-width: 80px;
    }
}

.event-table-action-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
        margin-left: 10px;
    }

    .timescope-filter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 11px;

        & > select {
            margin-left: 10px;
            width: 100px;
        }
    }
}

table {
    .unacknowledged {
        background-color: color.adjust(
            color.adjust($theme-red, $lightness: 25%),
            $alpha: -0.5
        );
    }

    td > div {
        position: relative;

        .tooltip {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }

        .old {
            color: $theme-red;
        }
    }
}

.button-group {
    display: flex;
    gap: 10px;
    align-items: center;
}
</style>

<template>
    <div>
        <div class="first-row">
            <div class="custom-msg-ctn">
                <span class="custom-msg">{{ $t('userMessage') }}</span>
                <InputBox
                    v-model="userMessage"
                    @keyDown.enter="sendUserMessage"
                />
                <div class="button-group">
                    <Button
                        :disabled="!userMessage"
                        @click="sendUserMessage"
                        small
                        outline
                        >{{ $t('send') }}</Button
                    >
                    <div v-if="!isCampaignViewer">
                        <Button small @click="acknowledgeAll">{{
                            $t('acknowledgeAll')
                        }}</Button>
                    </div>
                </div>
            </div>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr role="row">
                    <th>{{ $t('time') }}</th>
                    <th>{{ $t('message') }}</th>
                    <th>{{ $t('position') }}</th>
                    <th>{{ $t('acknowledgedBy') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="event in events" :key="event.id">
                    <td>
                        <div style="position: relative">
                            <div
                                class="tooltip"
                                v-tooltip.top="
                                    $t('generatedTimestampTooltip', {
                                        generated: event.generatedTimestamp,
                                    })
                                "
                                v-if="event.old"
                            />
                            {{ event.timestamp }}
                            <label v-if="event.old" class="old">*</label>
                        </div>
                    </td>
                    <td
                        :class="{
                            unacknowledged:
                                event.alert && !event.acknowledgedBy,
                        }"
                        v-html="event.message"
                    ></td>
                    <td>{{ event.locationStr ? event.locationStr : '--' }}</td>

                    <td>
                        <div v-if="event.alert">
                            <div v-if="event.acknowledgedBy">
                                {{ event.acknowledgedBy }}
                            </div>
                            <div v-else class="acknowledge-container">
                                <Button
                                    tiny
                                    outline
                                    @click="acknowledge(event.id)"
                                    >{{ $t('acknowledge') }}</Button
                                >
                            </div>
                        </div>
                        <div v-else>--</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import toastr from 'toastr';

import { mapState, mapGetters } from 'vuex';
import {
    ackEvent,
    ackAllEvents,
    sendUserGeneratedEvent,
} from '../api/campaigns';
import { STATUS_OK, STATUS_ERROR } from '../api/client';

export default {
    name: 'Events',

    data() {
        return {
            userMessage: '',
        };
    },

    computed: {
        ...mapGetters(['events', 'isCampaignViewer']),
    },

    methods: {
        acknowledge(eventId) {
            ackEvent(eventId);
        },

        sendUserMessage: async function () {
            const msg = this.userMessage;
            this.userMessage = '';

            if (msg && this.$store.state.campaignId) {
                const response = await sendUserGeneratedEvent(
                    this.$store.state.campaignId,
                    msg,
                );
                if (response.status === STATUS_OK) {
                    toastr.success(this.$t('messageSuccessful'));
                } else if (response.status === STATUS_ERROR) {
                    if (response.msg) {
                        toastr.error(this.$t(response.msg, response.msg_data));
                    } else {
                        toastr.error(this.$t('messageFailed'));
                    }
                }
            }
        },

        acknowledgeAll() {
            if (this.$store.state.campaignId) {
                ackAllEvents(this.$store.state.campaignId);
            }
        },
    },
};
</script>
